/* global window */
import Markdown from 'react-markdown';
import { React, Subscribe } from '@gasbuddy/react';
import { Text, Button } from '@gasbuddy/react-components';
import OfferContainer from '../common/state/OfferContainer';
import CategoryDetail from './CategoryDetail';
import CategoryList from './CategoryList';

import Styles from './style.css';

interface OfferProps {
  offer: OfferContainer,
}

const backgroundImageUrl = 'https://images.gasbuddy.io/autox240';
const logoUrl = 'https://images.gasbuddy.io/autox150';

const offerStringMapping = {
  details: 'Details',
  instructions: 'How It Works',
  fine_print: 'Fine Print',
};

function Offer({ offer: { state: offer } }: OfferProps) {
  const [category, setCategory] = React.useState();
  const onShopNowClick = React.useCallback(() => {

  }, []);

  const {
    link,
    partner,
    reward_text: rewardText,
    image_url: backgroundImage,
  } = offer;

  const backgroundStyle = {
    backgroundImage: `url('${backgroundImageUrl}/${backgroundImage}')`,
  };

  const imageStyle = {
    backgroundImage: `url('${logoUrl}/${partner?.image_url}')`,
  };

  const offerItemList = Object.keys(offerStringMapping)
    .filter(key => Object.keys(offer).includes(key))
    .map(val => ({ header: offerStringMapping[val], copy: offer[val] }));

  if (offer.categories?.length > 1) {
    offerItemList.splice(1, 0, () => <CategoryList className={Styles.categoryList} onDetail={this.onDetail} categories={offer.categories} />);
  }

  return (
    <div className={Styles.offerContainer}>
      {category && <CategoryDetail category={category} onClose={() => setCategory(null)} />}
      <div style={backgroundStyle} className={Styles.imageContainer} />
      <div style={imageStyle} className={Styles.partnerImageContainer} />
      <section className={Styles.detailsSection}>
        <header style={{ textAlign: 'center' }}>
          <div className={Styles.partnerName}>{partner?.name}</div>
          <Text color="teal" className={Styles.rewardText}>{rewardText}</Text>
          <br />
          <span className={Styles.gasbackText}>GasBack</span>
          <br />
          <br />
          {
            offerItemList.map((item, index) => {
              const isLast = index === (offerItemList.length - 1);
              if (typeof item === 'function') {
                return item();
              }
              return (
                <React.Fragment key={index.toString()}>
                  <div className={Styles.itemContainer}>
                    <header className={Styles.itemHeader}>{item.header}</header>
                    <div className={`
                    ${Styles.itemCopy}
                    ${isLast ? Styles.lastItemMargin : undefined}`}
                    >
                      <Markdown source={item.copy} />
                    </div>
                  </div>
                  {
                    !isLast
                    && <div className={Styles.divider} />
                  }
                </React.Fragment>
              );
            })
          }
        </header>
        <br />
        {

        }
      </section>
      <div className={Styles.shopNowContainer}>
        <Button
          className={Styles.shopNow}
          color="red"
          as="a"
          rounded
          fluid
          onClick={onShopNowClick}
          href={link}
        >
          {offer.willLogin ? 'LOG IN' : 'SHOP NOW'}
        </Button>
        {(typeof window !== 'undefined' && window.gbNative?.isBrowser) && (
          <div className={Styles.shopNowFooter}>
            {offer.identifier && (
              <span>
                GasBack will be earned for
                {` ${offer.identifier}. `}
                <a href={`${offer.loginLink}`}>Change Account</a>
              </span>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default () => <Subscribe to={[OfferContainer]}>{offer => <Offer offer={offer} />}</Subscribe>;
